import axios from "axios";
import {ADMIN_AGENT_ENDPOINT, ADMIN_RECEIPT_ENDPOINT, ADMIN_WAREHOUSE_ENDPOINT, PRINT_QRCODE_ENDPOINT} from "../../../../constants/endpoints";
import {ResponseModel} from "../../../../models/ResponseModel";
import {
  IProductWareHouse,
  IReceipt,
  ISearchProduct, ISearchSupplier, ISupplier
} from "../../../../models/WareHouseModel";
import {PaginateModel} from "../../../../models/PaginateModel";
import { ISearch } from "../../../../models/AgentProduct";
import { Product4ReceiptModel } from "../../../../models/ReceiptlModel";
import { IAxiosSuccess } from "../../../../models/AxiosModel";

export function getDetail(id?: string) {
  return axios.get<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/${id}`)
}

export function getListProducts(params?: ISearchProduct) {
  return axios.get<PaginateModel<IProductWareHouse>>(`${ADMIN_WAREHOUSE_ENDPOINT}/products`, {params})
}

export function getSuppliers(params?: ISearchSupplier) {
  return axios.get<PaginateModel<ISupplier>>(`${ADMIN_WAREHOUSE_ENDPOINT}/suppliers`, {params})
}

export function addReceipt(
  items: Product4ReceiptModel[], 
  payment_status: number | null = null, 
  payment_method: string | null= null,
  act_approve: number | null = null
) {
  return axios.post<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/manual-create`, {
    items: items,
    payment_status,
    payment_method,
    act_approve
  })
}

export function addReceiptWithFile(formData: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_RECEIPT_ENDPOINT}/manual-create`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function getProductList(params: ISearch, showLoading = true) {
  return axios.get(`${ADMIN_AGENT_ENDPOINT}/products`, {params, showLoading: showLoading})
}

export function approveReceipt(id: string, receipt: IReceipt) {
  return axios.post<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/approve/${id}`, receipt)
}

export function updateReceipt(id: number, receipt: IReceipt) {
  return axios.put<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/${id}`, receipt)
}

export function exportPdf(params: { id: number }) {
  return axios.post(`${ADMIN_RECEIPT_ENDPOINT}/export-pdf`, params)
  // return axios.post<Blob>(`${ADMIN_RECEIPT_ENDPOINT}/export-pdf`,params, {
  //   responseType: 'blob'
  // })
}

export function exportDetails(id: number) {
  return axios.get(`${ADMIN_RECEIPT_ENDPOINT}/export-details/${id}`, {responseType: 'blob'})
}

export function removeReceiptDetail(ids: number[]) {
  return axios.post<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/remove-details`, {ids: ids})
}

export function addInvoice(formData: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_RECEIPT_ENDPOINT}/invoice/add`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function updateInvoice(formData: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_RECEIPT_ENDPOINT}/invoice/update`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function delInvoice(id: number) {
  return axios.post<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/invoice/remove`, {id: id})
}

export function exportHtml(params: {reqData: {name: string, url: string, nums: number}[]}) {
  return axios.post(`${PRINT_QRCODE_ENDPOINT}`, params)
}


export function extractProductsFromImage(formData: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_RECEIPT_ENDPOINT}/init-receipt-by-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function cancelReceipt(id: number) {
  return axios.post<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/cancel`, {id})
}

export function adjustReceiptToInvoice(
  ids?: number[]
) {
  return axios.post<ResponseModel>(`${ADMIN_RECEIPT_ENDPOINT}/adjust-receipt-invoice`, {
    ids: ids ?? []
  })
}
